import getPriceInfoFromProduct from "@/utils/elevate/getPriceInfoFromProduct";
import { CustomProduct } from "@apptus/esales-api";
import { Market } from "@features/market/config/i18n-config";
import z from "zod";

export const trackedCustomProductSchema = z.object({
  ticket: z.string(),
  item_id: z.string(),
  item_name: z.string(),
  item_brand: z.string().nullish(),
  item_category: z.string().nullish(),
  item_category2: z.string().nullish(),
  item_category3: z.string().nullish(),
  price: z.number(),
});

export type TrackedCustomProduct = z.infer<typeof trackedCustomProductSchema>;

export function createTrackedCustomProduct(
  product: CustomProduct,
  market: Market,
): TrackedCustomProduct & { ticket: string } {
  const [variant] = product.variants;
  const priceInfo = getPriceInfoFromProduct(product, market);

  const totalCategoryCodes = product.custom?.totalCategoryCodes ?? [];

  const productCode = product.custom?.productCode?.[0]?.id || variant.key;

  return {
    ticket: variant.ticket || product.ticket,
    item_id: productCode,
    item_name: product.title,
    price: priceInfo.price,
    item_brand: product.brand,
    item_category: totalCategoryCodes[0]?.id,
    item_category2: totalCategoryCodes[1]?.id,
    item_category3: totalCategoryCodes[2]?.id,
  };
}
